import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { CLI_CURRENT_CINEMA_ID, PROGRAM_MOVIES_ITEMS } from '../constants/state'
import getMovieTitle from '../functions/getMovieTitle'
import { useExpanded } from '../Accessibility/Core/useExpanded'
import getFullyFilteredPerformances from '../functions/getFullyFilteredPerformances'
import MovieTimesContainerAccess from './MovieTimesContainerAccess'
import TabsManualActivationTablist from '../Accessibility/Tabs/TabsManualActivationTablist'
import MovieInformationAccess from './MovieInformationAccess'
import TabPanel from '../Accessibility/Tabs/TabPanel'
import { ItemHeaderAccess, ItemTextAccess, ItemWrapperAccess } from './ItemHelpersAccess'

const mapStateToProps = (state, ownProps) => ({
    item: getData(state, [PROGRAM_MOVIES_ITEMS, ownProps.id]),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID)
})

const ItemMovieAccess = ({
    htmlId,
    item,
    filterType,
    filterValue,
    currentCinemaId,
    queryStringValues = null,
    overviewFilterIgnoreOnPerformances = null,
    dayFilters = null,

    optionalTitle = '',
    optionalDescription = '',
    useMovieTitleAsSubtitle = false,
    useNoSubtitle = false
}) => {
    if(!item) {
        return ''
    }

    const [expandedId, toggleExpanded] = useExpanded()
    const { subTitle, descriptionShort, technologyAttributes, performances, alternativeLinks } = item
    const movieTitle = getMovieTitle(item)
    const headerTitle = optionalTitle ? optionalTitle : movieTitle
    const headerSubtitle = useMovieTitleAsSubtitle ? movieTitle : subTitle
    const text = optionalDescription ? optionalDescription : descriptionShort
    const {  purchaseblePerformances, fullyfilteredPerformance } = getFullyFilteredPerformances(performances, currentCinemaId, technologyAttributes, queryStringValues, filterType, filterValue, overviewFilterIgnoreOnPerformances, dayFilters)
    const hasPerformance = 0 !== purchaseblePerformances.length

    const tabIdInfo = `${htmlId}_info`
    const panelIdInfo = `${tabIdInfo}_panel`

    const tabIdTickets = `${htmlId}_tickets`
    const panelIdTickets = `${tabIdTickets}_panel`

    const isInfoExpanded = panelIdInfo === expandedId
    const isTicketExpanded = panelIdTickets === expandedId

    const tabConfig = [
        {
            transId: 'information',
            text: 'Film Info',
            id: tabIdInfo,
            controls: panelIdInfo
        },
        ... (hasPerformance ? [{
            transId: 'tickets',
            text: 'Tickets',
            id: tabIdTickets,
            controls: panelIdTickets
        }] : [])
    ]
    
    return (
        <ItemWrapperAccess>
            <ItemHeaderAccess
                title={headerTitle}
                subTitle={(!useNoSubtitle && headerSubtitle) && headerSubtitle}
            />

            <ItemTextAccess
                text={text}
            />

            <TabsManualActivationTablist
                labelledby='Film Informationen'
                tabConfig={tabConfig}
                expandedId={expandedId}
                toggleExpanded={toggleExpanded}
            />

            <TabPanel
                id={panelIdInfo}
                labelledby={tabIdInfo}
                isExpanded={isInfoExpanded}
            >
                {isInfoExpanded && <MovieInformationAccess
                    item={item}
                    filterType={filterType}
                    filterValue={filterValue}
                    queryStringValues={queryStringValues}
                />}
            </TabPanel>

            {hasPerformance && <TabPanel
                id={panelIdTickets}
                labelledby={tabIdTickets}
                isExpanded={isTicketExpanded}
            >
                {isTicketExpanded && <MovieTimesContainerAccess 
                    timesId={tabIdTickets}
                    movieTitle={movieTitle}
                    alternativeLinks={alternativeLinks}
                    fullyfilteredPerformance={fullyfilteredPerformance}

                />}
            </TabPanel>}
        </ItemWrapperAccess>
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemMovieAccess)